/**
 * iOS-style keyframe interpolation function.
 * Maps a progress value (0–1) to an output value using piecewise linear interpolation
 * across non-uniform keyframe positions.
 *
 * @param progress - Current animation progress (0 to 1)
 * @param keyframes - Output values at each keyframe position
 * @param positions - Keyframe positions (defaults to [0, 0.25, 0.5, 0.6, 0.75, 1.0])
 */
export function interpolateFromKeyframes(
  progress: number,
  keyframes: number[],
  positions: number[] = [0.0, 0.25, 0.5, 0.6, 0.75, 1.0]
): number {
  let lowerIndex = 0;
  let upperIndex = 1;

  for (let i = 0; i < positions.length - 1; i += 1) {
    if (progress >= positions[i] && progress <= positions[i + 1]) {
      lowerIndex = i;
      upperIndex = i + 1;
      break;
    }
  }

  if (progress > positions[positions.length - 1]) {
    return keyframes[keyframes.length - 1];
  }

  const lowerProgress = positions[lowerIndex];
  const upperProgress = positions[upperIndex];
  const lowerValue = keyframes[lowerIndex];
  const upperValue = keyframes[upperIndex];
  const t = (progress - lowerProgress) / (upperProgress - lowerProgress);

  return lowerValue + (upperValue - lowerValue) * t;
}
